import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const EmergencyContact = () => {
  const handleEmergencyCall = () => {
    window.open('tel:7998666660', '_self');
  };

  return (
    <div className="bg-gradient-to-br from-error/10 to-error/5 rounded-xl p-6 md:p-8 border-2 border-error/20">
      <div className="flex items-start gap-4 mb-6">
        <div className="w-12 h-12 rounded-full bg-error/20 flex items-center justify-center flex-shrink-0">
          <Icon name="AlertCircle" size={24} color="var(--color-error)" strokeWidth={2.5} />
        </div>
        <div>
          <h3 className="text-xl font-heading font-bold text-foreground mb-2">
            24/7 Emergency Support
          </h3>
          <p className="text-sm text-muted-foreground leading-relaxed">
            For urgent assistance during your journey, contact our emergency helpline immediately. Available round the clock for your safety and peace of mind.
          </p>
        </div>
      </div>
      <div className="space-y-4">
        <div className="flex items-center justify-between p-4 bg-card rounded-lg border border-border">
          <div className="flex items-center gap-3">
            <Icon name="Phone" size={20} className="text-error" />
            <div>
              <p className="text-xs text-muted-foreground">Emergency Hotline</p>
              <p className="text-lg font-bold text-foreground">7998666660</p>
            </div>
          </div>
          <Button
            variant="destructive"
            size="default"
            onClick={handleEmergencyCall}
            iconName="Phone"
            iconPosition="left"
          >
            Call Now
          </Button>
        </div>
        <p className="text-xs text-muted-foreground text-center">
          Average response time: &lt; 2 minutes
        </p>
      </div>
    </div>
  );
};

export default EmergencyContact;